var map = {
	"./2026-03-04-commodity-processing-beyond-china-a-strategic-outlook-for-traders.md": 2612,
	"./2026-03-04-test-title.md": 2528,
	"./2026-04-26-commodity-processing-beyond-china.md": 3895,
	"./2026-04-28-middle-east-weekly-overview-20–26-april-2026.md": 2423,
	"./2026-04-29-middle-east-weekly-overview-20–26-april-2026.md": 783,
	"./2026-05-10-middle-east-weekly-overview-04-–-10-may-2026.md": 4461,
	"./2026-06-04-oil-still-rules-azerbaijan-but-the-boom-is-fading.md": 501,
	"./2026-06-10-clearpic-check-access-to-official-company-registration-documents.md": 3260,
	"./2026-07-06-52-months-on-the-war-in-ukraine.md": 3578,
	"./2026-07-21-case-study-greek-and-offshore-shipping-nexus-safety-checks-for-a-commodities-firm.md": 1526,
	"./2026-08-05-humint-starts-before-the-phone-call.md": 5637,
	"./2026-08-06-case-study-grain-client-in-arbitration-with-defaulted-eastern-european-producer.md": 9667,
	"./2026-08-18-elevating-commodity-expertise-jeffrey-alam-joins-urus-advisory-board.md": 1504,
	"./2026-09-17-ai-driven-compliance-and-the-attribution-of-aml-criminal-liability-in-the-uae.md": 4421,
	"./2026-10-06-cross-border-asset-tracing-–-steel-commodities.md": 4089
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9569;